<template lang="pug">
  .container-fluid
    .row
      table.table.table-hover
        thead
          th {{$options.filters.translate('Code', lang)}}
          th {{$options.filters.translate('Place', lang)}}
          th {{$options.filters.translate('Object', lang)}}
          th {{$options.filters.translate('Error', lang)}}
          th {{$options.filters.translate('Description', lang)}}
          th R
          th I
          th {{$options.filters.translate('Level', lang)}}
        tbody
          tr(v-for="error in matrix", :key="error.id")
            td {{error.code}}
            td {{error.area}}
            td {{error.object}}
            td {{error.error}}
            td {{error.description}}
            td
              input.form-control.input-sm(type="text", v-model="error.R")
            td
              input.form-control.input-sm(type="text", v-model="error.I")
            td
              select.form-control.input-sm(v-model="error.level")
                option(v-for="(option, index) in levelOptions", :value="option.value", :key="index")
                  | {{ option.text }}
    .row
      .form-group
        transition(name="fade", mode="out-in")
          button.btn.btn-success.pull-right(@click="saveMatrix()", v-if="!saving") {{$options.filters.translate('Save changes', lang)}}
          .pull-right(v-else)
            i.fa.fa-spinner.fa-spin.fa-3x.fa-fw
    .row
      br
</template>
<script>
export default {
  name: 'matrix',
  props: ['lang'],
  data () {
    return {
      saving: false,
      matrix: [],
      levelOptions: [
        { text: '-', value: '0' },
        { text: '1', value: '1' },
        { text: '2', value: '2' },
        { text: '3', value: '3' }
      ]
    }
  },
  methods: {
    saveMatrix () {
      this.saving = true
      this.$http.post('error/setmatrix', {matrix: this.matrix})
        .then(response => {
          this.saving = false
          return response.json()
        })
        .then(data => {
          if (data && data.result === 'success') {
            this.$notify(this.$options.filters.translate('Matrix updated', this.lang), 'success')
          }
        })
    }
  },
  beforeCreate () {
    this.$http.get('error/getmatrix')
      .then(response => {
        return response.json()
      })
      .then(data => {
        const resultArray = []
        for (let key in data) {
          resultArray.push(data[key])
        }
        this.matrix = resultArray
      })
  }
}
</script>
<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/errors/Matrix.vue